(() => {
  function init() {
    document.querySelectorAll('[data-vv-caps-nav]').forEach(item => {
      if (item.dataset.initialized) return;
      item.dataset.initialized = 'true';
      const toggle = item.querySelector('.vv-caps-nav__toggle');
      const parent = item.querySelector('.vv-caps-nav__parent');
      const links = [...item.querySelectorAll('.vv-caps-nav__panel a')];
      let suppressFocus = false;
      const setOpen = open => {
        item.toggleAttribute('data-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        parent.setAttribute('aria-expanded', String(open));
      };
      item.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') setOpen(true); });
      item.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !item.contains(document.activeElement)) setOpen(false); });
      item.addEventListener('focusin', event => { if (!suppressFocus && event.target !== toggle) setOpen(true); });
      item.addEventListener('focusout', event => { if (!item.contains(event.relatedTarget)) setOpen(false); });
      toggle.addEventListener('click', () => setOpen(!item.hasAttribute('data-open')));
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          suppressFocus = true;
          parent.focus();
          suppressFocus = false;
        } else if (event.key === 'ArrowDown' && (event.target === parent || event.target === toggle)) {
          event.preventDefault(); setOpen(true); links[0]?.focus();
        }
      });
      document.addEventListener('pointerdown', event => { if (!item.contains(event.target)) setOpen(false); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
